module.exports = __webpack_public_path__ + "img/tian.5a8ca6ba.png";